import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: "Home",
    services: "Services",
    bookNow: "Book Now",
    signIn: "Sign In",
    getStarted: "Get Started",
    logout: "Logout",
    myBookings: "My Bookings",
    
    // Landing Page
    heroTitle: "Experience",
    heroPremium: "Premium",
    heroServices: "Services",
    heroSubtitle: "From rejuvenating spa treatments to Michelin-star dining, professional cleaning, and expert coding workshops — all under one roof.",
    exploreServices: "Explore Services",
    ourServices: "Our Services",
    servicesSubtitle: "Discover our range of premium services designed to elevate your lifestyle",
    ourLocations: "Our Locations",
    locationsSubtitle: "Visit us at any of our premium locations across Qatar, UAE, and India",
    readyToExperience: "Ready to Experience Excellence?",
    ctaSubtitle: "Book your appointment today and discover why FTASM Services is the preferred choice for premium services.",
    bookYourAppointment: "Book Your Appointment",
    staffPortal: "Staff Portal",
    allRightsReserved: "All rights reserved.",
    learnMore: "Learn more",
    
    // Services
    allServices: "All Services",
    spa: "Spa",
    kitchen: "Kitchen",
    cleaning: "Cleaning",
    coding: "Coding",
    ftasmSpa: "FTASM Spa",
    ftasmKitchen: "FTASM Kitchen",
    ftasmCleaning: "FTASM Cleaning",
    ftasmCoding: "FTASM's Coding Cracker",
    min: "min",
    
    // Booking
    bookYourExperience: "Book Your Experience",
    followSteps: "Follow the steps below to complete your booking",
    selectService: "Select a Service",
    selectLocation: "Select a Location",
    selectDateTime: "Select Date & Time",
    yourDetails: "Your Details",
    chooseDate: "Choose a Date",
    chooseTime: "Choose a Time",
    bookingSummary: "Booking Summary",
    service: "Service",
    location: "Location",
    date: "Date",
    time: "Time",
    total: "Total",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    numberOfGuests: "Number of Guests",
    guest: "Guest",
    guests: "Guests",
    specialRequests: "Special Requests (Optional)",
    specialRequestsPlaceholder: "Any special requirements or preferences...",
    preferredStaff: "Preferred Staff (Optional)",
    preferredStaffPlaceholder: "Staff member name if any",
    back: "Back",
    continue: "Continue",
    confirmBooking: "Confirm Booking",
    submitting: "Submitting...",
    
    // Auth
    welcomeBack: "Welcome back",
    createAccount: "Create your account",
    signUp: "Sign Up",
    password: "Password",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signingIn: "Signing in...",
    creatingAccount: "Creating account...",
    customerPortal: "Customer Portal",
    
    // My Bookings
    viewManageBookings: "View and manage your upcoming appointments",
    noBookingsYet: "No Bookings Yet",
    startBooking: "Start by booking one of our premium services!",
    bookingId: "Booking ID",
    pending: "Pending",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    
    // Staff Portal
    staffSignIn: "Staff Sign In",
    staffAccessDesc: "Access the staff dashboard to manage bookings and services",
    continueWithGoogle: "Continue with Google",
    onlyAuthorizedStaff: "Only authorized FTASM staff members can access this portal",
    dashboard: "Dashboard",
    bookings: "Bookings",
    customers: "Customers",
    availability: "Availability",
    overviewOperations: "Overview of your FTASM Services operations",
    totalBookings: "Total Bookings",
    pendingBookings: "Pending",
    confirmedBookings: "Confirmed",
    completedBookings: "Completed",
    cancelledBookings: "Cancelled",
    totalCustomers: "Customers",
    bookingsByCategory: "Bookings by Category",
    bookingsByBranch: "Bookings by Branch",
    pendingBookingsTitle: "Pending Bookings",
    noPendingBookings: "No pending bookings",
    manageBookings: "Manage all customer bookings",
    allBookings: "All Bookings",
    confirm: "Confirm",
    cancel: "Cancel",
    markComplete: "Mark Complete",
    noBookingsFound: "No bookings found",
    manageServices: "Manage services and pricing",
    addService: "Add Service",
    serviceName: "Service Name",
    description: "Description",
    price: "Price",
    duration: "Duration",
    category: "Category",
    imageUrl: "Image URL (optional)",
    createService: "Create Service",
    updateService: "Update Service",
    viewCustomerHistory: "View customer history and details",
    searchCustomers: "Search customers...",
    noCustomersYet: "No customers yet",
    noCustomersFound: "No customers found matching your search",
    manageSchedule: "Manage your work schedule across branches",
    addAvailability: "Add Availability",
    editAvailability: "Edit Availability",
    branch: "Branch",
    startTime: "Start Time",
    endTime: "End Time",
    availableForBookings: "Available for bookings",
    note: "Note (optional)",
    notePlaceholder: "e.g., Available for spa services only",
    update: "Update",
    add: "Add",
    selectDateToView: "Select a date to view or add availability",
    noAvailabilitySet: "No availability set for this date",
    addForThisDate: "Add for this date",
    available: "Available",
    unavailable: "Unavailable",
    
    // Currency
    currency: "Currency",
    language: "Language",
  },
  ar: {
    // Navigation
    home: "الرئيسية",
    services: "الخدمات",
    bookNow: "احجز الآن",
    signIn: "تسجيل الدخول",
    getStarted: "ابدأ الآن",
    logout: "تسجيل الخروج",
    myBookings: "حجوزاتي",
    
    // Landing Page
    heroTitle: "استمتع",
    heroPremium: "بخدمات",
    heroServices: "مميزة",
    heroSubtitle: "من علاجات السبا المنعشة إلى المطاعم الحائزة على نجمة ميشلان والتنظيف الاحترافي وورش البرمجة — كل ذلك تحت سقف واحد.",
    exploreServices: "اكتشف الخدمات",
    ourServices: "خدماتنا",
    servicesSubtitle: "اكتشف مجموعتنا من الخدمات المميزة المصممة لتحسين نمط حياتك",
    ourLocations: "مواقعنا",
    locationsSubtitle: "زورونا في أي من مواقعنا المميزة في قطر والإمارات والهند",
    readyToExperience: "هل أنت مستعد لتجربة التميز؟",
    ctaSubtitle: "احجز موعدك اليوم واكتشف لماذا خدمات FTASM هي الخيار المفضل للخدمات المميزة.",
    bookYourAppointment: "احجز موعدك",
    staffPortal: "بوابة الموظفين",
    allRightsReserved: "جميع الحقوق محفوظة.",
    learnMore: "اعرف المزيد",
    
    // Services
    allServices: "جميع الخدمات",
    spa: "سبا",
    kitchen: "مطبخ",
    cleaning: "تنظيف",
    coding: "برمجة",
    ftasmSpa: "سبا FTASM",
    ftasmKitchen: "مطبخ FTASM",
    ftasmCleaning: "تنظيف FTASM",
    ftasmCoding: "كود كراكر FTASM",
    min: "دقيقة",
    
    // Booking
    bookYourExperience: "احجز تجربتك",
    followSteps: "اتبع الخطوات أدناه لإكمال حجزك",
    selectService: "اختر خدمة",
    selectLocation: "اختر موقع",
    selectDateTime: "اختر التاريخ والوقت",
    yourDetails: "بياناتك",
    chooseDate: "اختر التاريخ",
    chooseTime: "اختر الوقت",
    bookingSummary: "ملخص الحجز",
    service: "الخدمة",
    location: "الموقع",
    date: "التاريخ",
    time: "الوقت",
    total: "المجموع",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    numberOfGuests: "عدد الضيوف",
    guest: "ضيف",
    guests: "ضيوف",
    specialRequests: "طلبات خاصة (اختياري)",
    specialRequestsPlaceholder: "أي متطلبات أو تفضيلات خاصة...",
    preferredStaff: "الموظف المفضل (اختياري)",
    preferredStaffPlaceholder: "اسم الموظف إن وجد",
    back: "رجوع",
    continue: "متابعة",
    confirmBooking: "تأكيد الحجز",
    submitting: "جاري الإرسال...",
    
    // Auth
    welcomeBack: "مرحباً بعودتك",
    createAccount: "أنشئ حسابك",
    signUp: "تسجيل",
    password: "كلمة المرور",
    dontHaveAccount: "ليس لديك حساب؟",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    signingIn: "جاري تسجيل الدخول...",
    creatingAccount: "جاري إنشاء الحساب...",
    customerPortal: "بوابة العملاء",
    
    // My Bookings
    viewManageBookings: "عرض وإدارة مواعيدك القادمة",
    noBookingsYet: "لا توجد حجوزات بعد",
    startBooking: "ابدأ بحجز إحدى خدماتنا المميزة!",
    bookingId: "رقم الحجز",
    pending: "قيد الانتظار",
    confirmed: "مؤكد",
    completed: "مكتمل",
    cancelled: "ملغي",
    
    // Staff Portal
    staffSignIn: "تسجيل دخول الموظفين",
    staffAccessDesc: "الوصول إلى لوحة تحكم الموظفين لإدارة الحجوزات والخدمات",
    continueWithGoogle: "المتابعة مع Google",
    onlyAuthorizedStaff: "فقط موظفي FTASM المصرح لهم يمكنهم الوصول إلى هذه البوابة",
    dashboard: "لوحة التحكم",
    bookings: "الحجوزات",
    customers: "العملاء",
    availability: "التوفر",
    overviewOperations: "نظرة عامة على عمليات خدمات FTASM",
    totalBookings: "إجمالي الحجوزات",
    pendingBookings: "قيد الانتظار",
    confirmedBookings: "مؤكدة",
    completedBookings: "مكتملة",
    cancelledBookings: "ملغية",
    totalCustomers: "العملاء",
    bookingsByCategory: "الحجوزات حسب الفئة",
    bookingsByBranch: "الحجوزات حسب الفرع",
    pendingBookingsTitle: "الحجوزات المعلقة",
    noPendingBookings: "لا توجد حجوزات معلقة",
    manageBookings: "إدارة جميع حجوزات العملاء",
    allBookings: "جميع الحجوزات",
    confirm: "تأكيد",
    cancel: "إلغاء",
    markComplete: "وضع علامة مكتمل",
    noBookingsFound: "لم يتم العثور على حجوزات",
    manageServices: "إدارة الخدمات والأسعار",
    addService: "إضافة خدمة",
    serviceName: "اسم الخدمة",
    description: "الوصف",
    price: "السعر",
    duration: "المدة",
    category: "الفئة",
    imageUrl: "رابط الصورة (اختياري)",
    createService: "إنشاء خدمة",
    updateService: "تحديث خدمة",
    viewCustomerHistory: "عرض سجل العملاء وتفاصيلهم",
    searchCustomers: "البحث عن العملاء...",
    noCustomersYet: "لا يوجد عملاء بعد",
    noCustomersFound: "لم يتم العثور على عملاء مطابقين لبحثك",
    manageSchedule: "إدارة جدول عملك عبر الفروع",
    addAvailability: "إضافة توفر",
    editAvailability: "تعديل التوفر",
    branch: "الفرع",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
    availableForBookings: "متاح للحجوزات",
    note: "ملاحظة (اختياري)",
    notePlaceholder: "مثال: متاح لخدمات السبا فقط",
    update: "تحديث",
    add: "إضافة",
    selectDateToView: "اختر تاريخاً لعرض أو إضافة التوفر",
    noAvailabilitySet: "لم يتم تعيين توفر لهذا التاريخ",
    addForThisDate: "إضافة لهذا التاريخ",
    available: "متاح",
    unavailable: "غير متاح",
    
    // Currency
    currency: "العملة",
    language: "اللغة",
  },
  hi: {
    // Navigation
    home: "होम",
    services: "सेवाएं",
    bookNow: "अभी बुक करें",
    signIn: "साइन इन",
    getStarted: "शुरू करें",
    logout: "लॉग आउट",
    myBookings: "मेरी बुकिंग",
    
    // Landing Page
    heroTitle: "अनुभव करें",
    heroPremium: "प्रीमियम",
    heroServices: "सेवाएं",
    heroSubtitle: "ताज़गी देने वाले स्पा उपचार से लेकर मिशेलिन-स्टार डाइनिंग, पेशेवर सफाई और विशेषज्ञ कोडिंग कार्यशालाएं — सब एक छत के नीचे।",
    exploreServices: "सेवाएं देखें",
    ourServices: "हमारी सेवाएं",
    servicesSubtitle: "आपकी जीवनशैली को बेहतर बनाने के लिए डिज़ाइन की गई हमारी प्रीमियम सेवाओं की श्रृंखला खोजें",
    ourLocations: "हमारे स्थान",
    locationsSubtitle: "कतर, यूएई और भारत में हमारे किसी भी प्रीमियम स्थान पर आएं",
    readyToExperience: "उत्कृष्टता का अनुभव करने के लिए तैयार हैं?",
    ctaSubtitle: "आज ही अपनी अपॉइंटमेंट बुक करें और जानें कि FTASM सेवाएं प्रीमियम सेवाओं के लिए पसंदीदा विकल्प क्यों हैं।",
    bookYourAppointment: "अपनी अपॉइंटमेंट बुक करें",
    staffPortal: "स्टाफ पोर्टल",
    allRightsReserved: "सर्वाधिकार सुरक्षित।",
    learnMore: "और जानें",
    
    // Services
    allServices: "सभी सेवाएं",
    spa: "स्पा",
    kitchen: "किचन",
    cleaning: "सफाई",
    coding: "कोडिंग",
    ftasmSpa: "FTASM स्पा",
    ftasmKitchen: "FTASM किचन",
    ftasmCleaning: "FTASM सफाई",
    ftasmCoding: "FTASM कोडिंग क्रैकर",
    min: "मिनट",
    
    // Booking
    bookYourExperience: "अपना अनुभव बुक करें",
    followSteps: "अपनी बुकिंग पूरी करने के लिए नीचे दिए गए चरणों का पालन करें",
    selectService: "सेवा चुनें",
    selectLocation: "स्थान चुनें",
    selectDateTime: "तारीख और समय चुनें",
    yourDetails: "आपका विवरण",
    chooseDate: "तारीख चुनें",
    chooseTime: "समय चुनें",
    bookingSummary: "बुकिंग सारांश",
    service: "सेवा",
    location: "स्थान",
    date: "तारीख",
    time: "समय",
    total: "कुल",
    fullName: "पूरा नाम",
    emailAddress: "ईमेल पता",
    phoneNumber: "फोन नंबर",
    numberOfGuests: "मेहमानों की संख्या",
    guest: "मेहमान",
    guests: "मेहमान",
    specialRequests: "विशेष अनुरोध (वैकल्पिक)",
    specialRequestsPlaceholder: "कोई विशेष आवश्यकता या प्राथमिकता...",
    preferredStaff: "पसंदीदा स्टाफ (वैकल्पिक)",
    preferredStaffPlaceholder: "स्टाफ सदस्य का नाम यदि कोई हो",
    back: "वापस",
    continue: "जारी रखें",
    confirmBooking: "बुकिंग की पुष्टि करें",
    submitting: "सबमिट हो रहा है...",
    
    // Auth
    welcomeBack: "वापसी पर स्वागत है",
    createAccount: "अपना खाता बनाएं",
    signUp: "साइन अप",
    password: "पासवर्ड",
    dontHaveAccount: "खाता नहीं है?",
    alreadyHaveAccount: "पहले से खाता है?",
    signingIn: "साइन इन हो रहा है...",
    creatingAccount: "खाता बनाया जा रहा है...",
    customerPortal: "ग्राहक पोर्टल",
    
    // My Bookings
    viewManageBookings: "अपनी आगामी अपॉइंटमेंट देखें और प्रबंधित करें",
    noBookingsYet: "अभी तक कोई बुकिंग नहीं",
    startBooking: "हमारी प्रीमियम सेवाओं में से एक बुक करके शुरू करें!",
    bookingId: "बुकिंग आईडी",
    pending: "लंबित",
    confirmed: "पुष्टि",
    completed: "पूर्ण",
    cancelled: "रद्द",
    
    // Staff Portal
    staffSignIn: "स्टाफ साइन इन",
    staffAccessDesc: "बुकिंग और सेवाओं को प्रबंधित करने के लिए स्टाफ डैशबोर्ड एक्सेस करें",
    continueWithGoogle: "Google के साथ जारी रखें",
    onlyAuthorizedStaff: "केवल अधिकृत FTASM स्टाफ सदस्य ही इस पोर्टल तक पहुंच सकते हैं",
    dashboard: "डैशबोर्ड",
    bookings: "बुकिंग",
    customers: "ग्राहक",
    availability: "उपलब्धता",
    overviewOperations: "आपके FTASM सेवाओं के संचालन का अवलोकन",
    totalBookings: "कुल बुकिंग",
    pendingBookings: "लंबित",
    confirmedBookings: "पुष्टि",
    completedBookings: "पूर्ण",
    cancelledBookings: "रद्द",
    totalCustomers: "ग्राहक",
    bookingsByCategory: "श्रेणी के अनुसार बुकिंग",
    bookingsByBranch: "शाखा के अनुसार बुकिंग",
    pendingBookingsTitle: "लंबित बुकिंग",
    noPendingBookings: "कोई लंबित बुकिंग नहीं",
    manageBookings: "सभी ग्राहक बुकिंग प्रबंधित करें",
    allBookings: "सभी बुकिंग",
    confirm: "पुष्टि करें",
    cancel: "रद्द करें",
    markComplete: "पूर्ण चिह्नित करें",
    noBookingsFound: "कोई बुकिंग नहीं मिली",
    manageServices: "सेवाएं और मूल्य निर्धारण प्रबंधित करें",
    addService: "सेवा जोड़ें",
    serviceName: "सेवा का नाम",
    description: "विवरण",
    price: "कीमत",
    duration: "अवधि",
    category: "श्रेणी",
    imageUrl: "इमेज URL (वैकल्पिक)",
    createService: "सेवा बनाएं",
    updateService: "सेवा अपडेट करें",
    viewCustomerHistory: "ग्राहक इतिहास और विवरण देखें",
    searchCustomers: "ग्राहकों को खोजें...",
    noCustomersYet: "अभी तक कोई ग्राहक नहीं",
    noCustomersFound: "आपकी खोज से मेल खाते कोई ग्राहक नहीं मिले",
    manageSchedule: "शाखाओं में अपना कार्य शेड्यूल प्रबंधित करें",
    addAvailability: "उपलब्धता जोड़ें",
    editAvailability: "उपलब्धता संपादित करें",
    branch: "शाखा",
    startTime: "प्रारंभ समय",
    endTime: "समाप्ति समय",
    availableForBookings: "बुकिंग के लिए उपलब्ध",
    note: "नोट (वैकल्पिक)",
    notePlaceholder: "उदा., केवल स्पा सेवाओं के लिए उपलब्ध",
    update: "अपडेट",
    add: "जोड़ें",
    selectDateToView: "उपलब्धता देखने या जोड़ने के लिए तारीख चुनें",
    noAvailabilitySet: "इस तारीख के लिए कोई उपलब्धता सेट नहीं है",
    addForThisDate: "इस तारीख के लिए जोड़ें",
    available: "उपलब्ध",
    unavailable: "अनुपलब्ध",
    
    // Currency
    currency: "मुद्रा",
    language: "भाषा",
  }
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('ftasm_language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('ftasm_language', language);
    // Set direction for RTL languages
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const languageOptions = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' }
];
